/**
 * Subdomain Detector — Detects if user is on the CRE Pro subdomain.
 *
 * At runtime, checks window.location.hostname to determine if the user
 * arrived via cre.fairpath.app (or localhost:5173 with ?cre=1 for dev).
 *
 * Vercel rewrites handle the subdomain → same deployment routing.
 * This module just detects which "entry point" the user is on.
 */

/**
 * Returns true if the current hostname indicates CRE Pro.
 *
 * Detection logic:
 *   - Production: hostname starts with "cre." (e.g., cre.fairpath.app)
 *   - Development: ?cre=1 query param OR hostname starts with "cre."
 */
export function isCRESubdomain(): boolean {
  if (typeof window === "undefined") return false;

  const hostname = window.location.hostname;

  // Production / preview: cre.fairpath.app or cre.fairpath-*.vercel.app
  if (hostname.startsWith("cre.")) return true;

  // Development: allow ?cre=1 override for local testing
  if (import.meta.env.DEV) {
    const params = new URLSearchParams(window.location.search);
    if (params.get("cre") === "1") return true;
  }

  return false;
}

/**
 * Get the base URL for the CRE Pro entry point.
 * Used for cross-linking between residential and commercial.
 */
export function getCREBaseUrl(): string {
  if (import.meta.env.DEV) {
    // In dev, use query param approach
    return `${window.location.origin}?cre=1`;
  }
  // Production: subdomain
  return "https://cre.fairpath.app";
}

/**
 * Get the base URL for the residential entry point.
 * Used for cross-linking from CRE back to residential.
 */
export function getResidentialBaseUrl(): string {
  if (import.meta.env.DEV) {
    return window.location.origin;
  }
  return "https://fairpath.app";
}
